import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import tableIcons from './tableIcons';
import Button from '../Button';
import "./index.css"

import { SellersOrdersTable } from './SellersOrdersTable';
import { useSettlementListHook } from '../../../hooks';
import { toast } from 'react-toastify';
import { Input, Modal, Switch } from 'antd';

const { TextArea } = Input;

const Table = ({
  key,
  classes = {},
  selectedDates = [],
  sellerId = "",
  title = "",
  tableConfig,
  noBorder = true,
  globalSearch = false,
  filtering = true,
  isTransactionHistory = false
}) => {
  const {
    sellers,
    isLoading,
    isPayNowLoading,
    localization,
    paginationData,
    isPayNowModalOpen,
    paymentData,
    errorMessages,
    updateSettlementAmount,
    togglePaymentModal,
    handlePayNow,
    handleInputChange,
    onPageChange,
    onFilterChange
  } = useSettlementListHook({
    isTransactionHistory,
    selectedDates,
    sellerId
  })

  const [config, setConfig] = useState([]);

  const actions = [
    {
      icon: () => {
        return (<Button size="small" label="Pay Now" className="pay-button"></Button>)
      },
      tooltip: 'Pay Now',
      onClick: (event, rowData) => {
        const amount = rowData.isAnyOrderSelected && rowData.settlementAmount
          ? rowData.settlementAmount
          : 0

        if (amount <= 0) {
          toast.warning("settlment amount is 0. please select orders for settlement")
        } else {
          //show modal
          togglePaymentModal(true, rowData)
        }
      }
    }
  ];

  const filterComponent = (props) => {
    return (<div>
      <input type="text"
        placeholder="Search"
        className={classes.filter}
        style={{ fontSize: '14px', backgroundColor: "transparent" }}
        onChange={
          (e) => props.onFilterChanged(props.columnDef.tableData.id, e.target.value)
        } /></div>)
  };

  useEffect(() => {
    if (tableConfig && tableConfig.columns) {
      const configuration = tableConfig.columns.map((configItem) => {
        return {
          ...configItem,
          sorting: configItem.filterAndSearch,
          filtering: configItem.filterAndSearch,
          filterComponent: filterComponent,
          filterPlaceholder: 'Search',
          searchable: configItem.filterAndSearch
        }
      });
      setConfig(configuration);
    }
  }, [tableConfig]);

  return (
    <>
      <MaterialTable
        key={key}
        style={{
          width: '100%',
          boxShadow: 'none',
          background: 'white',
          padding: '15px',
          borderRadius: noBorder ? '0px' : '5px'
        }}
        localization={localization}
        icons={tableIcons}
        actions={isTransactionHistory ? [] : actions}
        columns={config}
        data={sellers}
        title={title}
        isLoading={isLoading}
        totalCount={paginationData.total || 0}
        page={paginationData.page}
        onChangePage={onPageChange}
        onFilterChange={(event) => {
          onFilterChange(event)
        }}
        options={{
          toolbar: globalSearch,
          filtering: filtering,
          sorting: true,
          hideFilterIcons: true,
          actionsColumnIndex: -1,
          tableLayout: 'fixed',
          searchFieldAlignment: 'left',
          pageSize: paginationData.limit || 10,
          total: paginationData.total || 0,
          paginationType: 'stepped',
          pageSizeOptions: [10, 15, 20, 30, 50],
          headerStyle: {
            backgroundColor: '#f58634',
            color: 'white',
            padding: '8px 0 8px 16px',
          },
          filterCellStyle: {
            backgroundColor: '#fef3ea',
            padding: '8px 0 8px 16px',
          },
          searchFieldStyle: {
            borderRadius: '20px',
            border: '1px solid grey',
            padding: '5px 35px',
            marginBottom: '10px',
            display: 'none',
          },
          maxBodyHeight: "calc(100vh - 270px)",
        }
        }
        onRowClick={(event, rowData, togglePanel) => togglePanel()}
        detailPanel={(rowData) => {
          const sellerId = rowData.seller_id
          const isAllOrderSelected = rowData.isAllOrderSelected || false

          return <SellersOrdersTable
            isTransactionHistory={isTransactionHistory}
            isAllOrderSelected={isAllOrderSelected}
            sellerId={sellerId}
            sellerOrders={rowData.orders || []}
            updateSettlementAmount={(totalAmountData) => updateSettlementAmount(totalAmountData, rowData)} />
        }}
      />

      {
        !isTransactionHistory &&
        <Modal
          visible={isPayNowModalOpen}
          closable={true}
          title="Add Settlment Details"
          onCancel={() => togglePaymentModal(false)}
          footer={
            [
              <Button
                key="back"
                className="ml-2"
                label={"Close"}
                onClick={() => togglePaymentModal(false)} />,
              <Button
                key="submit"
                className="ml-2"
                type="primary"
                isLoading={isPayNowLoading}
                label={"Submit"}
                onClick={() => { handlePayNow() }} />
            ]
          }
        >
          <div>
            <div className='mb-2'>
              <label>Seller ID : </label>
              <span className='mx-1'>  <b>{paymentData.sellerId || ""}</b></span>
            </div>

            <div className='mb-2'>
              <label>Seller Name : </label>
              <span className='mx-1'> <b>{paymentData.business_name || ""}</b></span>
            </div>

            <div className='mb-2'>
              <label>Incentive amount : </label>
              <span className='mx-1'><b>&#8377;{(paymentData.payment_details && paymentData.payment_details.incentive_amount.toFixed(2)) || 0}</b></span>
            </div>

            <div className='mb-2'>
              <label>Settlement amount : </label>
              <span className='mx-1'><b>&#8377;{(paymentData.settlement_amount && paymentData.settlement_amount.toFixed(2)) || 0}</b></span>
            </div>

            <div className='mb-2'>
              <label>Total Amount : </label>
              <span className='mx-1'><b>&#8377;{(paymentData.settlement_amount + (paymentData?.pay_incentive ? paymentData?.payment_details?.incentive_amount : 0)).toFixed(2) || 0}</b></span>
            </div>

            <div className='mb-2'>
              <label>Sellers Bank account number : </label>
              <span className='mx-1'><b>{(paymentData.account_number) || "-"}</b></span>

              {/* <Input
              status={errorMessages.account_number ? "error" : ""}
              name={"account_number"}
              value={paymentData.account_number}
              placeholder="Bank account no."
              maxLength={16}
              onChange={handleInputChange}
            />
            {errorMessages.account_number && <span className='error-message'>{errorMessages.account_number}</span>} */}
            </div>

            <div className='mb-2'>
              <label>Sellers Bank account Code : </label>
              <span className='mx-1'><b>{(paymentData.bank_code) || "-"}</b></span>

              {/* <Input
              status={errorMessages.bank_code ? "error" : ""}
              name={"bank_code"}
              value={paymentData.bank_code}
              placeholder="Bank Code"
              maxLength={16}
              onChange={handleInputChange}
            />
            {errorMessages.bank_code && <span className='error-message'>{errorMessages.bank_code}</span>} */}
            </div>

            <div className='mb-3'>
              <div>Pay Incentive : </div>
              <Switch 
                name={"pay_incentive"}
                value={paymentData?.pay_incentive}
                placeholder="Google Pay Transaction ID"
                checked={paymentData?.pay_incentive}
                onChange={(event) => handleInputChange({target: {
                  name: 'pay_incentive',
                  value: event
                }})}
              />
              {errorMessages.pay_incentive && <span className='error-message'>{errorMessages.pay_incentive}</span>}
            </div>


            <div className='mb-3'>
              <div>Google Pay Transaction ID : </div>
              <Input
                status={errorMessages.transaction_id ? "error" : ""}
                name={"transaction_id"}
                value={paymentData.transaction_id}
                placeholder="Google Pay Transaction ID"
                maxLength={16}
                onChange={handleInputChange}
              />
              {errorMessages.transaction_id && <span className='error-message'>{errorMessages.transaction_id}</span>}
            </div>

            <div className='mb-3'>
              <div>Add any description if you want to</div>
              <TextArea
                name={"settlement_description"}
                value={paymentData.settlement_description}
                placeholder="Settlement description"
                rows={4}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </Modal >
      }

    </>
  );
};

export default Table;
